// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Bep-","footer":"ModalError_footer__1rjRD"};